<template>
  <div>
    <LayoutTitle :title="item.groupName" v-for="(item, index) in dynamicList" :key="item.groupId">
      <FormLayout
        ref="projectForm" 
        :readOnly="readOnly"
        :model="projectInfo"
        :list="generatePage(index)"
        @on-change-tree="checkPerson" 
        @on-change-all="person">
      </FormLayout>
    </LayoutTitle>
  </div>
</template>

<script>
import {timeFormat} from '@/utils'
import generateList from './generate-form'
import FormLayout from '@/components/layout/form'
import LayoutTitle from '@/components/layout/layout-title'
import { submitOrgSignUp, getOrgSignUp, editOrgSignUp } from '../../interface'

export default {
  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      show: false,
      projectInfo: {},
      dictMap: {},
      formLayout: [],
      groupId: '',
      dynamicList: []
    }
  },
  created () {
    this.bizLineCode = this.$decode(this.$route.query.bizLineCode, 'YWX01')
    const idMap = JSON.parse(sessionStorage.getItem('idMap'))
    this.orgId = this.$decode(sessionStorage.getItem(idMap[this.bizLineCode]))
    this.readOnly = this.$decode(this.$route.query.type) == 'see'
  },
  inject: ['getApplicationObjectId'],
  methods: {
    //生成表单和表格
    generatePage (index) {
      return generateList.call(this, index)
    },
    //重置表单校验
    resetFields () {
      if (Array.isArray(this.$refs.projectForm)) {
        this.$refs.projectForm.every(ref => {
          ref.resetFields()
        })
      } else {
        this.$refs.projectForm.resetFields()
      }
    },
    //获取信息
    async getPersonInfo (params) {
      await this.getCodeTable('DM14')
      await this.getCodeTable('GB4762')
      this.projectInfo = {}
      if (params) {
        // this.readOnly = !params.isReportState
        this.projectInfo.partyMemberNum = null
        this.projectInfo.employeeNum = null
        this.projectInfo.orgLeaderAge = null
        this.projectInfo.competeEmployeeNum = null
        this.projectInfo.leagueOrgPeopleNum = null
        this.projectInfo.leagueOrgMenNum = null
        this.projectInfo.leagueOrgWomenNum = null
        this.projectInfo.leagueOrgPartyMemberNum = null
        this.projectInfo.leagueOrgMemberNum = null
        this.projectInfo.leagueOrgAvgAge = null
        this.projectInfo.leagueOrgBachelorNum = null
        this.projectInfo.leagueOrgSpecialtyNum = null
        this.projectInfo.leagueOrgHighNum = null
        this.show = true
        getOrgSignUp({signUpId: params.signUpId, orgId: params.orgId}).then(({data}) => {
          if (params.quickFill) {
            data.isCancel = '0'
          }
          let isCancel = data.isCancel
          this.readOnly = isCancel == '1'
          this.projectInfo = { ...this.projectInfo, ...data }
          this.projectInfo.approvalBuildingDate = timeFormat(this.projectInfo.approvalBuildingDate)
          this.projectInfo.orgLeaderName = [{
            userId: this.projectInfo.orgLeaderId || '',
            userName: this.projectInfo.orgLeaderName
          }]
          //设置附件
          if (this.projectInfo.attachmentGroupId) {
            this.groupId = this.projectInfo.attachmentGroupId
            this.getActivityFiles(this.groupId).then(data => {
              this.$set(this.projectInfo, 'uploadFile', data)
            })
          } else {
            this.groupId = this.getUuid()
          }
          this.$emit('on-request', {
            ...data,
            isCancel: isCancel
          })
          //动态表单
          this.dynamicList = this.list
          this.transferDataType()
        })
      } else {
        this.readOnly = false
        this.groupId = this.getUuid()
        //动态表单
        this.dynamicList = this.list
        this.transferDataType()
      }
    },
    judgeRefs () {
      let refs = this.$refs.projectForm
      if (!Array.isArray(refs)) {
        refs = [this.$refs.projectForm]
      }
      const req = refs.map(ref => ref.validateify())
      return req
    },
    //将date对象格式化
    dateFormat (obj) {
      Object.keys(obj).forEach(item => {
        if (obj[item] instanceof Date) {
          obj[item] = timeFormat(obj[item])
        }
      })
      return obj
    },
    //提交
    submitPersonInfo (recommendInfo) {
      const applicationObjectId = this.getApplicationObjectId()
      Promise.all(this.judgeRefs()).then(res => {
        const result = res.every(v => v)
        if (!result) {
          this.$emit('on-close', 'valid')
          this.$Message.error('表单校验失败')
          return
        }
        const requestMethod = recommendInfo.signUpId ? editOrgSignUp : submitOrgSignUp
        const params = this.dateFormat({
          ...recommendInfo,
          ...this.projectInfo,
          orgLeaderId: this.projectInfo.orgLeaderName ? this.projectInfo.orgLeaderName[0].userId : '',
          orgLeaderName: this.projectInfo.orgLeaderName ? this.projectInfo.orgLeaderName[0].userName : '',
          attachmentGroupId: this.groupId,
          applicationObjectId: applicationObjectId
        })
        requestMethod(params, {
          headers: {
            'Content-Type': 'application/json'
          },
          disabledData: true
        }).then(({data}) => {
          this.$Message.success('提交成功')
          if (!recommendInfo.signUpId) {
            let type = 'addType'  //修改
            this.$emit('on-request', {
              ...recommendInfo,
              signUpId: data.signUpId
            }, type) //修改
          } else {
            this.$emit('on-close')
          }
        }).catch(() => {
          this.$emit('on-close', 'valid')
        })
      })
    },
    //转换对应的值
    transferDataType () {
      if (!this.dynamicList.length) return
      this.dynamicList.forEach((item) => {
        item.formPropertyList.forEach(val => {
          const value = this.projectInfo[val.propertyCode]
          if (val.widgetType == 'InputNumber') {
            this.$set(this.projectInfo, val.propertyCode, value ?? null)
          }
          if (val.widgetType == 'DatePicker') {
            this.$set(this.projectInfo, val.propertyCode, value ? timeFormat(value) : '')
          }
        })
      })
    },
    //选择负责人
    person ([item], key) {
      // this.$set(this.projectInfo, 'orgLeaderGender', (item.gender || '') + '')
      // this.$set(this.projectInfo, 'orgLeaderJobNumber', item.userCode || '')
      // this.$set(this.projectInfo, 'orgLeaderPolitical', (item.political || '') + '')
      // this.$set(this.projectInfo, 'orgLeaderPhone', item.phone || '')
      // this.$set(this.projectInfo, 'orgLeaderAge', item.userAge ? item.userAge - 0 : null)
      if( key == 'orgLeaderName') {
        this.$set(this.projectInfo, 'orgLeaderPhone', item.phone)
        this.$set(this.projectInfo, 'orgLeaderJobNumber', item.userCode) //负责人工号
        this.$set(this.projectInfo, 'orgLeaderPolitical', item.political)
        this.$set(this.projectInfo, 'orgLeaderGender', item.gender + '')
        this.$set(this.projectInfo, 'idCardNum', item.idCardNum)
        this.computedAge()
      }
    },
    //选择单位
    checkPerson (data, key) {
      if (key == 'orgName') {
        this.projectInfo.orgId = data[0].id
        this.getParentOrgInfo(data[0].id)
      } else if (key == 'parentOrgName') {
        this.projectInfo.parentOrgId = data[0].id
      } 
    },
    //根据组织id获取上级组织
    getParentOrgInfo (orgId) {
      if (!orgId) return
      this.$ajax({
        url: 'api-general/module/portal/org/getParentOrg',
        method: 'get',
        data: {
          orgId: orgId,
          bizLineCode: this.bizLineCode
        }
      }).then(({data}) => {
        this.$set(this.projectInfo, 'parentOrgName', data.data.shortName)
        this.$set(this.projectInfo, 'parentOrgId', data.data.orgId)
      })
    },
    //获取文件信息
    getActivityFiles (groupId) {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-uum/file/listFilesByGroupId',
          method: 'GET',
          data: {
            isPage: false,
            groupId: groupId
          }
        }).then(({data}) => {
          resolve(data.data || [])
        })
      })
    },
    //获取数据字典
    getCodeTable (code) {
      this.$set(this.dictMap, code, [])
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/user/outGetList',
          method: 'get',
          data: {
            dictCode: code,
            merge: false,
            bizLineCode: this.bizLineCode || 'YWX01'
          }
        }).then(({data}) => {
          this.dictMap[code] = data.data.map(item => ({
            label: item.title,
            value: item.value
          }))
          resolve()
        })
      })
    },
    //计算年龄和司龄
    computedAge () {
      const date = this.projectInfo.idCardNum.substring(6, 14).replace(/(\d{4})(\d{2})(\d{2})/, function (str, $1, $2, $3) {
        return `${$1}/${$2}/${$3}`
      })
      const distance = new Date().getTime() - new Date(date).getTime()
      const age = Math.floor(distance / 1000 / 60 / 60 / 24 / 365)
      this.$set(this.projectInfo, 'orgLeaderAge', age)
    },
    getUuid () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    }
  },
  components: {
    FormLayout,
    LayoutTitle
  }
}
</script>